import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'app-simple-export-buttons',
	templateUrl: './simple-export-buttons.component.html',
	styleUrls: ['./simple-export-buttons.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SimpleExportButtonsComponent implements OnInit {

	@Input() showPrint = false;
	@Input() showSendEmail = false;
	@Input() showDownloadPdf = false;
	@Input() showNew = false;
	@Input() numberOfButton = 0;
	@Output() emitPrint: EventEmitter<any> = new EventEmitter<any>();
	@Output() emitSendEmail: EventEmitter<any> = new EventEmitter<any>();
	@Output() emitDownloadPdf: EventEmitter<any> = new EventEmitter<any>();
	@Output() emitNew: EventEmitter<any> = new EventEmitter<any>();

	constructor( ) { }

	ngOnInit(): void {
	}

	print() {
		this.emitPrint.emit();
	}
	sendEmail() {
		this.emitSendEmail.emit();
	}
	downloadPdf() {
		this.emitDownloadPdf.emit();
	}
	new() {
		this.emitNew.emit();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/simple-export-buttons/simple-export-buttons.component.ts